import { Check, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const plans = [
  {
    name: "Intro",
    price: "₹8,000",
    note: "per year + ₹29,999 license registration",
    description: "For smaller teams getting started.",
    features: ["Patti book entry", "Supplier payments", "Payment voucher entry", "Bank records", "Basic analytics", "Single-user login", "Up to 20,000 transactions", "Email support"],
  },
  {
    name: "Plus",
    price: "₹12,000",
    note: "per year + ₹29,999 license registration",
    description: "For growing businesses that need more automation and control.",
    popular: true,
    features: ["Everything in Intro", "Vehicle logistics management", "Advanced analytics", "Thermal & standard invoice printing", "User authority and roles", "Up to 4 users", "Backup & restore options", "WhatsApp transaction notifications", "Chat & phone support"],
  },
  {
    name: "Elite",
    price: "₹15,000",
    note: "per year + ₹29,999 license registration",
    description: "For larger teams that need deeper accounting and support.",
    features: ["Everything in Plus", "Full accounting suite", "Staff attendance tracking", "Advanced reporting & analytics", "Up to 8 users", "SMS & WhatsApp integration", "Priority support with dedicated manager"],
  },
];

export default function Pricing() {
  return (
    <div className="bg-[#f7fbfd]">
      <section className="relative overflow-hidden border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 pb-14 pt-16 text-center sm:px-6 lg:px-8 lg:pb-20">
          <div className="eyebrow mx-auto w-fit"><Sparkles className="h-4 w-4" /> Simple pricing, clear value</div>
          <h1 className="mt-6 text-4xl font-bold tracking-tight text-[#003448] sm:text-6xl">Choose the plan that fits your operation.</h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600">
            Start small, add more control as your business grows, and keep the same core MarketMind experience.
          </p>
          <div className="mt-5 inline-flex rounded-full bg-[#eaf8fe] px-4 py-2 text-sm font-semibold text-[#007ca9]">30-day free trial</div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-5 lg:grid-cols-3">
          {plans.map((plan) => (
            <div key={plan.name} className={`relative flex flex-col overflow-hidden rounded-[28px] border ${plan.popular ? "border-[#00aef0] shadow-[0_20px_60px_rgba(0,174,240,0.16)]" : "border-slate-200"} bg-white`}>
              {plan.popular && <div className="bg-[#003448] px-6 py-2 text-center text-xs font-bold uppercase tracking-[0.14em] text-white">Most popular</div>}
              <div className="flex flex-1 flex-col p-7 sm:p-8">
                <p className="text-sm font-semibold text-[#00aef0]">{plan.name}</p>
                <p className="mt-4 text-4xl font-bold tracking-tight text-[#003448]">{plan.price}</p>
                <p className="mt-1 text-xs font-medium text-slate-500">{plan.note}</p>
                <p className="mt-4 min-h-[48px] text-sm leading-6 text-slate-600">{plan.description}</p>
                <Link to="/#contact" className={`mt-7 inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3 font-semibold ${plan.popular ? "bg-[#003448] text-white" : "bg-[#eaf8fe] text-[#003448]"}`}>Start free trial <ArrowRight className="h-4 w-4" /></Link>
                <div className="my-7 h-px bg-slate-200" />
                <p className="text-sm font-bold text-[#003448]">Included</p>
                <ul className="mt-4 space-y-3">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex gap-3 text-sm text-slate-600">
                      <span className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#eaf8fe] text-[#00aef0]"><Check className="h-3.5 w-3.5" /></span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8">
          <div className="grid gap-5 sm:grid-cols-3">
            <div><p className="text-sm font-bold text-[#003448]">Need a tailored setup?</p><p className="mt-1 text-sm text-slate-500">We can discuss your users, workflows and deployment needs.</p></div>
            <div><p className="text-sm font-bold text-[#003448]">Need a demo?</p><p className="mt-1 text-sm text-slate-500">See dashboards and automation using your real business flow.</p></div>
            <div className="sm:text-right"><a href="mailto:sales@lightningtechnologies.net" className="inline-flex items-center gap-2 font-semibold text-[#00aef0]">Talk to sales <ArrowRight className="h-4 w-4" /></a></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
